import "./nordic.ts";
import { recordSubmission } from "./submit.ts";

/**
 * Contact / book-a-demo form: required-field validation with live error-clearing,
 * then an inline personalised confirmation with a reference number. The submission
 * is recorded to the D1-backed endpoint (best-effort).
 */
const form = document.getElementById("contactFormEl") as HTMLFormElement | null;
if (form) {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const fieldOf = (el: Element): Element | null => el.closest(".field");
  const setText = (id: string, text: string) => {
    const e = document.getElementById(id);
    if (e) e.textContent = text;
  };

  for (const el of form.querySelectorAll<HTMLElement>("input,select,textarea")) {
    el.addEventListener("input", () => fieldOf(el)?.classList.remove("invalid"));
    el.addEventListener("change", () => fieldOf(el)?.classList.remove("invalid"));
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const problems: HTMLElement[] = [];
    const fail = (el: HTMLElement) => {
      fieldOf(el)?.classList.add("invalid");
      problems.push(el);
    };

    const name = document.getElementById("name") as HTMLInputElement;
    const email = document.getElementById("email") as HTMLInputElement;
    const company = document.getElementById("company") as HTMLInputElement;
    const topic = document.getElementById("topic") as HTMLSelectElement;
    const message = document.getElementById("message") as HTMLTextAreaElement;

    if (!name.value.trim()) fail(name);
    if (!emailRe.test(email.value.trim())) fail(email);
    if (!company.value.trim()) fail(company);
    if (!topic.value) fail(topic);
    if (!message.value.trim()) fail(message);
    if (problems.length) {
      problems[0].focus();
      return;
    }

    const ref = `NIL-C${Math.floor(10000 + Math.random() * 90000)}`;
    recordSubmission("contact", {
      ref,
      name: name.value.trim(),
      email: email.value.trim(),
      company: company.value.trim(),
      topic: topic.value,
      message: message.value.trim(),
      hp: form.querySelector<HTMLInputElement>('[name="hp"]')?.value ?? "",
    });
    const first = name.value.trim().split(" ")[0];
    setText("successTitle", `Thanks, ${first}.`);
    setText(
      "successMsg",
      `We’ve logged your message about “${topic.value.replace(/&amp;/g, "&")}”. ` +
        `The right person on our team will reply to ${email.value.trim()} within one business day.`,
    );
    setText("successRef", `Reference ${ref}`);
    const formHead = document.getElementById("formHead");
    if (formHead) formHead.style.display = "none";
    form.style.display = "none";
    document.getElementById("success")?.classList.add("show");
  });
}
